import script from "./SmallFavouriteProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmallFavouriteProduct.vue?vue&type=script&lang=ts&setup=true"

import "./SmallFavouriteProduct.vue?vue&type=style&index=0&id=4d6f8d16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6f8d16"]])

export default __exports__